import { setShare } from '@didi/webx-js'
/**
 * @description 设置 aio 分享
 * @author wangfupeng
 */

// 分享小程序的默认配置
const DEFAULT_EXT = {
    appId: 'gh_233a09669f6e',
    path: '/pages/bridgePage/index?type=webView&contentType=_CONTENTTYPE_&needLogin=_NEEDLOGIN_&url=_URL_'
}

/**
 * 格式化分享数据
 * @param {Object} shareData 分享数据 page.global.share
 */
export function getShareData (data) {
    if (data.ext == null || data.ext.appId == null) {
        data.ext = DEFAULT_EXT
    }

    // 设置分享数据
    const shareData = Object.assign(
        // 默认数据
        {
            title: '滴滴出行',
            icon: 'https://static.diditaxi.com.cn/activity/img-mall/share.jpg',
            content: '滴滴一下，美好出行',
            qzone: false,
            sina_weibo: false,
            qq_appmsg: false,
            success () {
            }
        },
        // 分享数据
        {
            title: data.title,
            content: data.content,
            url: '',
            type: data.type,
            ext: data.ext || {},
            shareCardContent: data.shareCardContent || '滴滴出行',
            shareCardIcon: data.shareCardIcon || '',
            icon: data.thumbUrl.indexOf('http') > -1 ? data.thumbUrl : `http:${data.thumbUrl}`,
            shadowImg: data.shadowImg || ''
        }
    )
    shareData.url = data.url || ''
    shareData.url = shareData.url.trim() || location.href.replace(/token=[^&]*&?/, '')
    return shareData
}

/**
 * 设置分享
 * @param {Object} shareData 分享数据 page.global.share
 */
export default function (data) {
    const shareData = getShareData(data)
    // 设置分享
    setShare(shareData)
}
